import classnames from 'classnames';
import React from 'react';

type TagStatus = 'info' | 'success' | 'warning' | 'alert' | 'neutral' | 'light';
type TagType = 'outline' | 'solid';
type TagSize = 'condensed' | 'standard' | 'expanded';

interface TagProps {
	/** The text content of the tag */
	value: string;
	/** Color status of the tag */
	status?: TagStatus;
	/** Visual style: outline (border + light bg) or solid (filled bg) */
	type?: TagType;
	/** Size variant affecting padding */
	size?: TagSize;
	/** Show a colored status indicator dot */
	showIndicator?: boolean;
	/** Additional CSS class name */
	className?: string;
	/** Data-qa attribute for test automation */
	dataqa?: string;
}

function Tag({
	value,
	status = 'info',
	type = 'outline',
	size = 'standard',
	showIndicator = true,
	className,
	dataqa,
}: TagProps) {
	const tagClassName = classnames(
		'common-ui-tag',
		type,
		status,
		size,
		className
	);

	return (
		<div className={tagClassName} {...(dataqa && { 'data-qa': dataqa })}>
			{showIndicator && <span className="tag-indicator" />}
			<span className="tag-text">{value}</span>
		</div>
	);
}

export default Tag;
